import { RestClient } from '@libs/rest-client';
import { Book } from '../models';
import type { BookRaw } from '../models';

async function fetchBooks() {
  return Book.fromRaws(await RestClient.fa.post<BookRaw[]>('/book/all'));
}

export { fetchBooks };
